var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sparkline',{attrs:{"type":"bar","value":_vm.value,"line-width":"0.99","height":"5","gradient":_vm.gradient}}),_c('v-sparkline',{attrs:{"type":"bar","labels":_vm.labels,"value":_vm.hourRuler,"line-width":"0.99","height":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }